import contactModule from './contactModule'

const modules = {
  contactModule,
}

export default {
  modules,
}
